export default __webpack_public_path__ + "static/media/IMG_0294.1743ff1d.JPG";